export const isLocal = window.location.hostname === "localhost";

// export const domain = isLocal ? 'https://1.hse.quadecco.com' : window.location.origin;
export const domain = isLocal ? 'https://wuerth.hse40.com' : window.location.origin;

// export const apiUrl = `//${domain}/api/v1`;
export const apiUrl = `${domain}/api/v1`;



// WEBPACK FOOTER //
// ./src/config/index.js